// THE WORDS ON THE /apply CALENDAR STEP'S PHONE FIELD, in one place.
//
// The field is required, its label is the plain "Phone number" from the moment
// the calendar shows, and nothing sits under it. Change the wording here and
// nowhere else; the picker reads this constant and holds no copy of its own for
// the field.
//
// Client-safe on purpose: no server-only import, so the picker bundle can read it.
export const CALENDAR_PHONE_FIELD_COPY = {
  /** The label above the field before a time is picked. Once he taps a time the
   * field is the booking's number and keeps the WhatsApp variant where it applies. */
  label: "Phone number",
} as const
